
import { mapGetters } from 'vuex';

export default {
    name: 'VRadio',
    props: {
        radioValue: {
            type: [String, Number, Boolean],
            required: true
        },
        error: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        value: {
            type: [String, Number, Boolean],
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        validate: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        ...mapGetters('profile', [
            'role'
        ])
    },
    methods: {
        handleChange() {
            if (!this.readonly && !this.disabled) this.$emit('input', this.radioValue);
        }
    }
}
